import api from '@/service/product.js';

const state = {
  webProductModel: {
    rowCount: 1,
    model: "chessSort",
    type: "horizontal_1",
    icon: "",
    iconColor: "#000000",
    image: {
      percentage: 100,
    },
    product: {
      nameSize: "15",
      nameColor: "#000000",
      contentSize: "15",
      contentColor: "#000000",
      showMemberPrice: false,
      priceColor: "#dc3545",
      memberPriceColor: "#000000"
    },
  },
  default: {
    webProductModel: {
      rowCount: 1,
      model: "chessSort",
      type: "horizontal_1",
      icon: "",
      iconColor: "#000000",
      image: {
        percentage: 100,
      },
      product: {
        nameSize: "15",
        nameColor: "#000000",
        contentSize: "15",
        contentColor: "#000000",
        showMemberPrice: false,
        priceColor: "#dc3545",
        memberPriceColor: "#000000"
      },
    }
  }
};

const actions = {
  getWebProductModel({
    state,
    commit
  }) {
    let result = api.getWebProductModel();
    result.then((data) => {
      if (data.data.state) {
        commit("setWebProductModel", data.data.result);
      } else {
        const temp = _.cloneDeep(state.default.webProductModel);
        commit("setWebProductModel", temp);
      }
    })
    return result;
  },

  saveWebProductModel({
    state,
    commit
  }, data) {
    let result = api.saveWebProductModel(data);
    result.then((data) => {
      if (data.data.state) {
        commit("setWebProductModel", data.data.result);
      }
    })
    return result;
  },
};

const mutations = {
  setWebProductModel(state, data) {
    state.webProductModel = data;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
